var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "model-table" },
    [
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeName,
                  expression: "activeName",
                },
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "header-cell-style": { background: "#F5F6F7" },
                size: "medium",
              },
            },
            [
              _vm.activeName === "property"
                ? [
                    _c("el-table-column", {
                      attrs: { prop: "id", label: "DP ID", width: "80" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(scope.row.id || "-") +
                                    "\n          "
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1791011549
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "name", label: "属性名称" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(scope.row.name || "-") +
                                    "\n          "
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2129237207
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "数据传输类型",
                        formatter: _vm.formatPermission,
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "valueType", label: "数据类型" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      scope.row.valueType.type
                                        ? _vm.formatValueType[
                                            scope.row.valueType.type
                                          ]
                                        : "-"
                                    ) +
                                    "\n          "
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1492479593
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "数据说明" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.valueType.elements
                                  ? _c(
                                      "div",
                                      _vm._l(
                                        scope.row.valueType.elements,
                                        function (item, index) {
                                          return _c("div", { key: index }, [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  item.value + "： " + item.text
                                                ) +
                                                "\n              "
                                            ),
                                          ])
                                        }
                                      ),
                                      0
                                    )
                                  : _c("span", [_vm._v("-")]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1642217311
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "description", label: "备注" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(scope.row.description || "-") +
                                    "\n          "
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2769219606
                      ),
                    }),
                  ]
                : [
                    _vm.activeName === "event"
                      ? _c("el-table-column", {
                          attrs: { prop: "EID", label: "EID", width: "80" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(scope.row.eid || "-") +
                                        "\n          "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1773435512
                          ),
                        })
                      : _vm._e(),
                    _vm.activeName === "action"
                      ? _c("el-table-column", {
                          attrs: { prop: "AID", label: "AID", width: "80" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(scope.row.aid || "-") +
                                        "\n          "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            510768124
                          ),
                        })
                      : _vm._e(),
                    _c("el-table-column", {
                      attrs: {
                        prop: "name",
                        label:
                          _vm.activeName === "event" ? "事件名称" : "动作名称",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n            " +
                                  _vm._s(scope.row.name || "-") +
                                  "\n          "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "id", label: "标识符" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n            " +
                                  _vm._s(scope.row.id || "-") +
                                  "\n          "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm.activeName === "event"
                      ? _c("el-table-column", {
                          attrs: { prop: "valueType", label: "事件级别" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(scope.row.level || "-") +
                                        "\n          "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            4013667590
                          ),
                        })
                      : _vm._e(),
                    _c("el-table-column", {
                      attrs: { prop: "description", label: "备注" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                "\n            " +
                                  _vm._s(scope.row.description || "-") +
                                  "\n          "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
              _c("el-table-column", {
                attrs: { fixed: "right", label: "操作", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.developStatus == 1
                          ? _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content:
                                    "产品已发布，信息不可修改，如需修改，请返回开发状态",
                                  placement: "top",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      size: "operate",
                                      disabled: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDelete(scope.row.id)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                ),
                              ],
                              1
                            )
                          : _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "text",
                                  size: "operate",
                                  disabled:
                                    _vm.tableData.length === 1 ||
                                    _vm.rolesCode === "SALE",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDelete(scope.row.id)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            ),
                        _vm.activeName !== "property"
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "operate" },
                                on: {
                                  click: function ($event) {
                                    return _vm.viewProperties(
                                      scope.row.propertyIds
                                    )
                                  },
                                },
                              },
                              [_vm._v("查看属性")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }